import { AppEntrySubscription } from '@mzc-watchover/terashite-entry-graphql'
import { assign } from 'lodash'
import { isNil, keys, reduce } from 'lodash/fp'
import { FormInputDatas } from '../../types'

export type EditFormFormat = {
  lastName: string
  firstName: string
  lastNameKana: string
  firstNameKana: string
  postalCode: string
  pref: string
  city: string
  town: string
  place?: string
  phone: string
}

export const mergeSubscriptionDataFromForm = (
  data: AppEntrySubscription,
  form: EditFormFormat
): AppEntrySubscription => {
  return reduce((output: AppEntrySubscription, key: string) => {
    const value = form[key as keyof typeof form]
    if(key === 'lastNameKana') {
      assign(output, {
        lastNameHiragana: value
      })
    }else if(key === 'firstNameKana') {
      assign(output, {
        firstNameHiragana: value
      })
    }else if (key === 'postalCode') {
      assign(output, {
        zip: value
      })
    }else if(key === 'pref') {
      assign(output, {
        state: value
      })
    }else if(key === 'town' || key === 'place') {
      assign(output, {
        address: `${form.town}${!isNil(form.place) ? form.place : ''}`
      })
    }else if(key === 'phone') {
      assign(output, {
        phoneNo: value
      })
    }else{
      assign(output, {
        [key]: value
      })
    }
    return output
  }, data)(keys(form))
}
export const mergeEntryDataFromForm = (
  data: FormInputDatas,
  form: EditFormFormat
): FormInputDatas => {
  return reduce((output: FormInputDatas, key: string) => {
      assign(output, {
        [key]: form[key as keyof typeof form]
      })
    return output
  }, data)(keys(form))
}